import { Injectable, inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { CanActivate, Router, UrlTree } from '@angular/router'
import { selectUser } from '../store/auth/auth.selectors'
import { Store } from '@ngrx/store'
import { map, Observable, of, take } from 'rxjs'

@Injectable({ providedIn: 'root' })
// export class GuestGuard implements CanActivate {
//   private platformId = inject(PLATFORM_ID)
//   constructor(private router: Router) {}
//   store = inject(Store)
//   canActivate(): boolean {
//     if (!isPlatformBrowser(this.platformId)) {
//       return true // server pe block mat karo
//     }

//     const token = localStorage.getItem('accessToken')
//     if (token) {
//       this.store.select(selectUser).pipe(
//         take(1),
//         map(user => {
//           // 🔥 ADMIN BYPASS
//           const isAdmin = user?.userRoles?.some(
//             r => r?.role?.name?.toLowerCase() === 'admin' && r?.status === 'Active'
//           )

//           if (isAdmin) {
//             // console.log('🔥 ADMIN BYPASS → ALLOWED')
//             this.router.navigate(['/user/dashboard'])
//           } else {
//             this.router.navigate(['user/employeeDashboard'])
//           }
//         })
//       )

//       return false
//     }
//     return true
//   }
// }

//13 july 2026 gps
export class GuestGuard implements CanActivate {
  private readonly platformId = inject(PLATFORM_ID)
  private readonly store = inject(Store)
  private readonly router = inject(Router)

  canActivate(): Observable<boolean | UrlTree> {
    // SSR par login route allow karo
    if (!isPlatformBrowser(this.platformId)) {
      return of(true)
    }

    const token = localStorage.getItem('accessToken')

    // Login nahi hai to auth pages allow
    if (!token) {
      return of(true)
    }

    // Logged-in user ko dashboard bhejo
    return this.store.select(selectUser).pipe(
      take(1),
      map(user => {
        const isAdmin =
          user?.userRoles?.some(
            role => role?.role?.name?.toLowerCase() === 'admin' && role?.status === 'Active'
          ) ?? false

        return isAdmin
          ? this.router.createUrlTree(['/user/dashboard'])
          : this.router.createUrlTree(['/user/employeeDashboard'])
      })
    )
  }
}
